export const getDashboardList="/getDashboardList" //getDashboardList
export const getDeviceListAndGNSSData="/getDeviceListAndGNSSData" //getDeviceListAndGNSSData
export const getDashboardEmbedUrl="/getDashboardEmbedUrl" //getDashboardEmbedUrl
export const getSendMsgToken="/getSendMsgToken" //getSendMsgToken
export const getDeviceList = "/getDeviceList" //getDeviceList
export const updateShadowToDevice = "/updateShadowToDevice" //updateShadowToDevice